export { default as BaseTemplate } from './base-template';
